<app-loader [showLoader]="isLoading"></app-loader>
<app-loader [showLoader]="loader || isConnectionClosing"></app-loader>

<div class="public-wrap">
  <div class="container">
    <div class="row back-with-register">
      <div class="col-md-4 back-link-outer mb-0 d-flex">
        <a class="back-link no-wrap" role="button" (click)="goBack()">
          <img alt="back-icon" src="../assets/images/back.svg" /> Back To
          Auction Details
        </a>
      </div>

      <div class="col-md-8 right-wrap" *ngIf="
          auctionDetail?.saleType?.registrationFormat == 1 &&
          auctionDetail.isRegistrationActive &&
          (auctionDetail.auctionStatus == 1 ||
            auctionDetail.auctionStatus == 2) &&
          !auctionDetail.loggedInUser
        ">
        <div class="register-to-bid-outer">
          <div class="register-to-bid">
            <div class="for-icon">
              <img alt="register-icon" src="../assets/images/register-bid.svg" />
            </div>

            <div class="for-message">
              <p class="m-0">
                To start bidding please
                <br />
                register to this auction.
              </p>
            </div>

            <div class="for-btn">
              <button type="button" class="btn btn-colored" role="button"
                (click)="goToRegister(auctionDetail?.auctionCode)">
                Register To Bid
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row mb-3">
      <div class="col-md-3">
        <h3 class="register-name mb-0 pb-2">Lot Catalog</h3>
      </div>

      <div class="col-md-9 text-right">
        <button class="btn btn-colored btn-lot-icon mb-2" role="button" (click)="downloadCSV()">
          <img alt="download-icon" class="download-icon" src="./assets/images/download-white.svg" />
          Download Catalog
        </button>
        <button class="btn btn-white-border btn-lot-icon2 ml-2 mb-2" *ngIf="
            ![0, helpTexts.none].includes(auctionDetail?.saleType?.showHelpText)
          " role="button" (click)="
            openHelpModal(helpTemplate, auctionDetail?.saleType?.showHelpText)
          ">
          <img alt="help-icon" class="help-icon" src="./assets/images/help-colored.svg" />
          Bidding Help
        </button>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="auction-with-logo mb-3">
      <div class="left-logo">
        <img class="auction-logo" alt="auction-logo" AuctionDefaultImage *ngIf="auctionDetail"
          [image]="auctionDetail.clientLogo" />
      </div>
      <div class="right-logo">
        <div class="d-flex mb-2">
          <span class="card-badge no-card min-width-auto badge-dark">{{ auctionDetail?.saleType?.publicName }}
          </span>
        </div>

        <h3 class="auc-name mb-2">{{ auctionDetail?.title }}</h3>
        <p class="auc-des mb-3" [innerHTML]="auctionDetail?.tagline"></p>
        <p class="auc-location mb-2">
          {{ auctionDetail?.auctionLocations | locationNames }}
        </p>
        <p class="auc-address m-0" [innerHtml]="
            auctionDetail?.saleType?.auctionDate
              | auctionDateFormat
                : auctionDetail?.auctionStatus
                : auctionDetail?.timeZoneName
                : auctionDetail?.startDateTime
                : auctionDetail?.endDateTime
                : auctionDetail?.saleType?.dateText
          "></p>
        <p class="auc-address m-0" *ngIf="auctionDetail?.generalBuyersPremiumText != '0'">
          A Buyers Premium applies to this sale, please click More Info for BP
          rates
        </p>
        <p class="auc-more-info" *ngIf="!showMore" role="button" (click)="showMore = true">
          <span>
            More Info
            <img alt="arrow" class="ml-2" src="/assets/images/arrow-down-colored.svg" />
          </span>
        </p>
        <p class="auc-more-info" *ngIf="showMore">
          <span role="button" (click)="showMore = false">
            Less Info
            <img alt="arrow" class="ml-2 arrow-rotated" src="/assets/images/arrow-down-colored.svg" />
          </span>
        </p>
        <div class="auc-less-info" *ngIf="showMore">
          <div class="auc-less-info-inner">
            <span class="less-name">Currency</span>
            <span class="less-dtl">{{ auctionDetail?.currencyName }}</span>
          </div>
          <div class="auc-less-info-inner" *ngIf="auctionDetail?.generalBuyersPremiumText != '0'">
            <span class="less-name">Buyer's Premium</span>
            <span class="less-dtl" *ngIf="auctionDetail?.creditCardBuyersPremiumText == 'null'; else ccBlock"
              [innerHTML]="auctionDetail?.generalBuyersPremiumText+'%'"></span>
            <ng-template #ccBlock>
              <span class="less-dtl" [innerHTML]="auctionDetail?.creditCardBuyersPremiumText"></span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row pt-4">
      <div class="col-8 col-md-9 col-auto left-lot">
        <h3 class="total-lot mb-2">{{ totalAuctionLots }} Lots</h3>
        <p class="lot-des">
          Lot Closing : Lots will close in
          {{ auctionDetail?.staggerLotCloseTime }} second intervals beginning
          with the first Lot on
          {{ auctionDetail?.endDateTime | date: "EEEE, MMMM d At h:mm a" }}
          {{ auctionDetail?.timeZoneName }}
        </p>
      </div>
      <div class="col-4 col-md-3 col-auto right-lot ml-auto text-right">
        <button class="lgv-btn mr-1 mr-md-3" [ngClass]="{ active: !showListView }" role="button"
          (click)="showListView = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g fill="currentColor" fill-rule="nonzero">
                <path
                  d="M1210.335 346.889c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm8.889 0c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm-8.89 1.778h-3.556v3.555h3.555v-3.555zm8.888 0h-3.555v3.555h3.555v-3.555zM1210.335 338c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm8.889 0c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm-8.89 1.778h-3.556v3.555h3.555v-3.555zm8.888 0h-3.555v3.555h3.555v-3.555z"
                  transform="translate(-1205 -338) matrix(-1 0 0 1 2426 0)" />
              </g>
            </g>
          </svg>
        </button>
        <button class="lgv-btn" [ngClass]="{ active: showListView }" role="button" (click)="showListView = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13">
            <g fill="none" fill-rule="evenodd">
              <g fill="currentColor" fill-rule="nonzero">
                <path
                  d="M1266.071 350.143c.513 0 .929.416.929.928 0 .513-.416.929-.929.929h-14.142c-.513 0-.929-.416-.929-.929 0-.512.416-.928.929-.928h14.142zm0-5.572c.513 0 .929.416.929.929 0 .513-.416.929-.929.929h-14.142c-.513 0-.929-.416-.929-.929 0-.513.416-.929.929-.929h14.142zm0-5.571c.513 0 .929.416.929.929 0 .512-.416.928-.929.928h-14.142c-.513 0-.929-.416-.929-.928 0-.513.416-.929.929-.929h14.142z"
                  transform="translate(-1251 -339) matrix(-1 0 0 1 2518 0)" />
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>

    <div *ngIf="auctionAnnouncement">
      <div class="alertWithIcon">
        <img alt="announcement" src="../assets/images/announcement.svg" />
        <p [innerHTML]="auctionAnnouncement"></p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="auction-search">
          <div class="form-group mb-4 no-float-fields no-float-with-search search-width">
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Search" [formControl]="searchControl" />
            </mat-form-field>
            <span class="filter-icon search-icon" role="button" (click)="resetSearch()"
              *ngIf="searchControl.value != null; else showSearch">
              <img alt="cross" src="../assets/images/cross.svg" title="clear" />
            </span>

            <ng-template #showSearch>
              <span class="search-icon">
                <img alt="search" title="search" src="/assets/images/search-icon2.svg" />
              </span>
            </ng-template>
          </div>

          <div class="form-group mb-4 no-float-fields auc-width d-none">
            <mat-select [value]="lotTypes" (selectionChange)="lotTypeFilter($event.value)" placeholder="Filter Lots">
              <mat-option *ngFor="let lotTypes of lotTypesData" [value]="lotTypes.value">{{ lotTypes.text }}
              </mat-option>
            </mat-select>
          </div>

          <div class="form-group mb-4 no-float-fields sort-width">
            <mat-select [value]="categories" (selectionChange)="categoryTypeFilter($event.value)"
              placeholder="Category">
              <mat-option [value]="null">All</mat-option>
              <mat-option *ngFor="let category of lotCategoriesData" [value]="category">{{ category }}
              </mat-option>
            </mat-select>
          </div>

          <div class="form-group mb-4 no-float-fields sort-width">
            <mat-select [value]="locations" (selectionChange)="locationTypeFilter($event.value)"
              placeholder="All Locations">
              <mat-option [value]="null">All</mat-option>
              <mat-option *ngFor="let location of lotLocationData" [value]="location">{{ location }}
              </mat-option>
            </mat-select>
          </div>

          <div class="form-group mb-4 no-float-fields sort-width featuredLotToggle">
            <p class="body-txt-16">
              Show Featured Lots
              <label class="switch-slider">
                <input type="checkbox" class="form-check-input1 slide-check-input" [value]="showFeaturedLots"
                  [checked]="showFeaturedLots" (change)="featuredLotButtonChange($event.target.checked)" />
                <span class="slider round"></span>
              </label>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-4 pb-2">
      <app-lot-connection-mode *ngIf="!readOnlyCatalog"></app-lot-connection-mode>
    </div>

    <div class="pagination-mt-0">
      <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
        (page)="onPageChange($event)" [pageSizes]="pageSizes" (selectedPageSize)="onPageSizeChange($event)"
        *ngIf="totalAuctionLots !== 0">
      </app-paginator>
    </div>

    <div class="row" *ngIf="loggedInUser > 0">
      <div class="col-12 text-right lot-selected mb-3">
        <span class="select-no" *ngIf="selectedLotsForBulk?.length != 0">
          <strong>{{ selectedLotsForBulk?.length | number }} Lot(s) Selected</strong>
          <ng-container *ngIf="selectedLotsForBulk?.length > 1">
            For Bulk Bid
          </ng-container>
        </span>
      </div>
    </div>

    <div class="empty-state-container empty-pad-2" *ngIf="totalAuctionLots == 0; else showTable">
      <div class="empty-state-content">
        <img alt="empty-state" src="../../../../assets/images/empty-state-icon.svg" />
        <h3 class="_heading">No Lots Found</h3>
      </div>
    </div>

    <ng-template #showTable>
      <div class="row lot-box-outer lot-catalog-view" [ngClass]="{ 'lot-list-view': showListView }">
        <div class="col-12 lot-boxes" *ngFor="
            let item of auctionLotData
              | paginate
                : {
                    id: 'server',
                    itemsPerPage: pageSize,
                    currentPage: pageNumber,
                    totalItems: totalAuctionLots
                  };
            index as i
          " [ngClass]="{ 'col-md-6 col-lg-4': !showListView }">
          <auction-lot-card [lotData]="item" [isListView]="showListView" [bulkBidResult]="bulkBidSubmissionResult"
            [bulkBid]="isBulkBid" [serverTime]="sendTimerToLotCard" [latestLotData]="
              sendLotDataToLotCard && sendLotDataToLotCard?.lotId === item?.id
                ? sendLotDataToLotCard
                : null
            " (selectedLotData)="getSelectedLots($event)" (submitBulkBid)="isBulkBidReview($event)"
            [featuredSyncedInfo]="featuredLotInfo ? featuredLotInfo : null">
          </auction-lot-card>
        </div>
      </div>
    </ng-template>
    <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
      (page)="onPageChange($event)" [pageSizes]="pageSizes" (selectedPageSize)="onPageSizeChange($event)"
      *ngIf="totalAuctionLots !== 0">
    </app-paginator>
  </div>
</div>

<ng-template #helpTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Help</h4>
    <button type="button" class="close pull-right circle-icon m-0" aria-label="Close" role="button"
      (click)="modalRef.hide()">
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body">
    <h1 class="modal-inner-hdg mt-0 mb-2">Catalog & Bidding</h1>
    <div class="des" [innerHTML]="helpTextData"></div>
  </div>
</ng-template>

<ng-template #reviewModal>
  <div class="modal-header pl-3">
    <h4 class="modal-title pull-left">Review Bids</h4>
    <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button"
      (click)="closeReviewModal()">
      <img alt="cross" _ngcontent-lrm-c188="" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="column-list">
      <div class="parts">
        <div class="left-wrap">Auction</div>
        <div class="right-wrap">{{ auctionDetail.title | titlecase }}</div>
      </div>

      <div class="parts">
        <div class="left-wrap">Bidder</div>
        <div class="right-wrap">
          Paddle No. {{ userPaddleNumber }}, {{ userFullName | titlecase }}
        </div>
      </div>
    </div>

    <div class="data-table-wrap w-100 review-bids-wrapper">
      <table aria-label="table" class="w-100 table-with-border review-bids-table">
        <tbody>
          <tr class="mat-row" *ngFor="let lot of selectedLotsForBulk; let idx = index">
            <td class="mat-cell column-1 listing-data-entry table-with-row-header">
              <span class="td-header">Lot #</span>
              {{ lot.lotNumber }}
            </td>
            <td class="mat-cell column-2 listing-data-entry table-with-row-header yellow-bg">
              <span class="td-header">Lot Description</span>
              {{ lot.description | characterLimit: 50 }}
            </td>
            <td class="mat-cell column-3 listing-data-entry table-with-row-header">
              <span class="td-header">Current</span>
              {{ lot.currentBid | auctionCurrency: auctionDetail.currencyName }}
            </td>
            <td class="mat-cell column-4 listing-data-entry table-with-row-header yellow-bg">
              <span class="td-header">New Bid</span>
              {{ lot.newBid | auctionCurrency: auctionDetail.currencyName }}
              <div class="reviewBidError" *ngIf="lot.newBid < lot.nextRequiredBid">
                <img alt="invalid bid" class="mr-2" src="assets/images/bidError.svg" />
                <p>
                  <strong>Invalid Bid:</strong> Bid of
                  {{ lot.newBid | auctionCurrency: auctionDetail.currencyName }}
                  is lower than next required bid of
                  {{
                  lot.nextRequiredBid
                  | auctionCurrency: auctionDetail.currencyName
                  }}
                </p>
              </div>
            </td>
            <td class="mat-cell column-5 listing-data-entry table-with-row-header">
              <span *ngIf="
                  selectedLotsForBulk?.length > numberOfminLotRequiredForBulkBid
                " role="button" (click)="removeLotFromReviewBids(idx)">Delete</span>
              <a class="hover-icon delete-icon custom-tooltip custom-tooltip2" tooltip="Vivamus sagittis" role="button"
                (click)="removeLotFromReviewBids(idx)"></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="changeInSelectedBulkLots">
      <p>Note : New Bid has been placed. Please bid again.</p>
    </ng-container>

    <div class="review-btns-wrap mt-3">
      <ng-container *ngIf="!changeInSelectedBulkLots">
        <button [disabled]="!showBulkSubmitBtn" type="button" class="btn btn-colored" role="button"
          (click)="submitBulkBid()">
          Submit Bids
        </button>
      </ng-container>
      <button type="button" class="btn btn-white-border" role="button" (click)="closeReviewModal()">
        Cancel
      </button>
      <span class="d-flex align-items-center text-danger" *ngIf="submitBidError">{{submitBidError}}</span>
    </div>
  </div>
</ng-template>
